import React, { useMemo } from 'react';
import styled from 'styled-components';

import Icon from 'components/icons/icon';

import theme, {bp, color} from 'settings/theme';


type Props = {
  text: string,
  stars: number,
  reviewerName: string,
  className?: string
};

// Component
const Component: React.FC<Props> = (props) => {

  const starsArray = useMemo(() => [...(new Array(Math.floor(props.stars)))], [props.stars]);
  const starsHalf = useMemo(() => (props.stars % 1 === 0.5), [props.stars]);

	return(

    <StyledComponent className={`review paddingHorizontal paddingVertical ${props.className ? props.className : ''}`}>

      <div style={{flex:'1 1 auto'}}>

        <div className="review-text-wrapper">

          <div className="review-text">

            <div className="review-quote-start">
              <Icon iconName="quotes" />
            </div>

            <div className="review-quote-end">
              <div className="review-quote-end-inner">
                <Icon iconName="quotes" iconDirection="up" />
              </div>
            </div>

            {props.text}

          </div>

        </div>

      </div>

      <div className="review-details">
        <div className="review-name">
          {props.reviewerName}
        </div>
        <div className="review-stars">
          {starsArray.map((item: any, index: number) => {return <Icon iconName="star" key={index} />})}
          {starsHalf && <Icon iconName="star-half" />}
        </div>
      </div>

    </StyledComponent>
        
	);

}



export default Component;


// Styles
const StyledComponent = styled.div`

  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: solid 1px ${color.lines};
  border-bottom: solid 1px ${color.lines};
  background-color: white;

  .review-text-wrapper{
    position: relative;
    display: flex;
    justify-content: stretch;
    align-items: stretch;

    &::after {
      content: "";
      clear: both;
      display: table;
    }
  }

  .review-text{

    width: 100%;
    margin-bottom: 40px;
    font-size: 14px;

    &::after {
      content: "";
      clear: both;
      display: table;
    }

    > :last-item{margin: 0;}

  }

  .review-quote-start{
    float: left;
    margin-right: 15px;
    margin-bottom: 5px;
  }

  .review-quote-end{

    --top: 60px;
    --width: 44px;
    --height: 80px;
    
    width:  100%;
    height: 100%;
    float: right;
    margin-top: calc(0 - var(--height));
    
    shape-outside: polygon(calc(100% - var(--width)) calc(100% - var(--height)), 100% calc(100% - var(--height)), 100% 100%, calc(100% - var(--width)) 100%);
    clip-path: polygon(calc(100% - var(--width)) calc(100% - var(--height)), 100% calc(100% - var(--height)), 100% 100%, calc(100% - var(--width)) 100%);
      
  }

  .review-quote-end-inner{
    position: absolute;
    bottom: 40px;
    right: 10px;
  }

  .review-details{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }

  .review-name{
    margin-right: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .review-stars{

    white-space: nowrap;

    .icon{

      display: inline-block;
      width: 18px;
      height: 18px;

      svg{
        fill: ${color.orange(50)};
      }

    }

  }


  @media (min-width: ${bp(3)}) {
    border-left: solid 1px ${color.lines};
    border-right: solid 1px ${color.lines};
  }


`